import { useApolloClient } from '@apollo/client';
import UserDataQuery from './UserDataQuery';
import { formatIsoDate } from '../../Helpers/dateFormatter';

const UserDataConnectorApollo = ({ children }) => {
  const client = useApolloClient();

  const fetch = async () => {
    try {
      const date = formatIsoDate(new Date());

      const result = await client.query({
        query: UserDataQuery,
        variables: { date },
        fetchPolicy: 'network-only',
      });

      const email = result?.data?.me?.email ?? '';
      const id = result?.data?.me?.id ?? '';
      const baseCalories = result?.data?.dailyTracker?.data?.baseCalories ?? 0;
      const systemOfMeasures = result?.data?.me?.systemOfMeasures ?? 'si';
      localStorage.setItem('userEmail', email);
      localStorage.setItem('userId', id);
      localStorage.setItem('trackerEnabled', baseCalories > 0 ? 'true' : 'false');
      localStorage.setItem('systemOfMeasures', systemOfMeasures);
      localStorage.setItem('userCreated', result?.data?.me?.created ?? '');

      return result;
    } catch (err) {
      console.error('Failed to fetch user data', err);
      throw err;
    }
  };

  return children({
    userDataOnDemand: fetch,
  });
};

export default UserDataConnectorApollo;
